require('./bootstrap');

import Vue from 'vue'
import {assets, router} from './helpers/shared'

const { EncryptStorage } = require('encrypt-storage');

const encryptStorage = new EncryptStorage('$2y$10$KqB2fi2qHO4EmPM40mc7jubbJT2pM4Sg02eZbG3t1fYKBUpMi1Klm', {
    prefix: '@google',
    storageType: 'localStorage',
});
Vue.prototype.$storage = encryptStorage

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.component('admin-login', require('./pages/admin/auth/login').default);
Vue.component('admin-verify', require('./pages/admin/auth/verify').default);
Vue.component('register-phone', require('./pages/admin/auth/register-phone').default);
Vue.component('register-password', require('./pages/admin/auth/password').default);
Vue.component('create-password', require('./pages/admin/auth/create-password').default);

Vue.prototype.$assets = (...args) => assets(...args);
Vue.prototype.$router = (...args) => router(...args);

new Vue({
    el: '#app',
});
